define('lq/util',['underscore'], function (_) {
	'use strict';

    var convertListOfKeyValuesToObject = function (sourceObject, ignoredProperties) {
        if (!(sourceObject instanceof Array) || sourceObject.length === 0) {
            return sourceObject;
        }

        var theObject = {};

        for (var i = 0; i < sourceObject.length; i++) {
            var item = sourceObject[i];

            var value = (item.value !== undefined) ? item.value : item.Value;
            var key = (item.key !== undefined) ? item.key : item.Key;

            if (ignoredProperties && ignoredProperties.indexOf(key) !== -1) {
                theObject[key] = value;
            } else {
                theObject[key] = convertListOfKeyValuesToObject(value);
            }
        }
        return theObject;
    };

    var cloneData = function (data) {
        return data === undefined ? undefined
            : JSON.parse(JSON.stringify(data));
    };

    // Source: URI syntax standard (RFC3986) Appendix B. at: http://tools.ietf.org/html/rfc3986#appendix-B
    var uriRegex = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");

    var parseUri = function (uri) {
        var match = uri.match(uriRegex);
        if (match) {
            return {
                scheme    : match[2],
                authority : match[4],
                path      : match[5],
                query     : match[7],
                fragment  : match[9],
                toString  : function () {
                    // Section 5.3 http://tools.ietf.org/html/rfc3986#section-5.3
                	return (this.scheme ? this.scheme + ":" : "") +
                        (this.authority ? "//" + this.authority : "") +
                        this.path +
                        (this.query ? "?" + this.query : "") +
                        (this.fragment ? "#" + this.fragment : "");
                }
            };
        }
    };

    var formatUriQuery = function (query) {
        return _.map(query, function (value, key) { return key + '=' + value; })
            .join('&');
    };

    var parseUriQuery = function (query) {
        return _.chain(query.split('&'))
            .compact()
            .map(function (param) {
                var split = param.split('=');
                var rest = split.slice(1).join('=');
                return [split[0], rest]; // [key, value]
            })
            .object()
            .value();
    };

    var addOrSetQueryParameter = function (queryString, name, value) {
        var query = parseUriQuery(queryString || '');
        query[name] = value;
        return formatUriQuery(query);
    };

    var addOrSetQueryParameterInUrl = function (url, name, value) {
        var parsedUri = parseUri(url);
        parsedUri.query = addOrSetQueryParameter(parsedUri.query, name, value);
        return parsedUri.toString();
    };

    var convertRelativeHyperlinkToHostName = function (hyperlink) {

    	var uri = parseUri(hyperlink);

    	// we don't use relative urls, they would need to be guids,
    	// that's rather awkward for the users and unlikely to be useful
    	if (uri.path[0] !== '/' && !uri.authority) { // relative uri without hostname (still might have scheme)
    		uri.authority = uri.path;
    		uri.path = '';
    		return uri.toString();
    	}

    	return hyperlink;
    };

    var getPropertyByPathArray = function (obj, pathArray) {
    	var current = obj;

    	_.each(pathArray, function (property) {
    		current = _.isObject(current) ? current[property] : undefined;
    	});

    	return current;
    };

    var getPropertyByPath = function (obj, path) {
    	return getPropertyByPathArray(obj, typeof path === "number" ? [path] : path.split('.'));
    };

    var removePropertyByPath = function (obj, path) {
    	var pathArray = typeof path === "number" ? [path] : path.split('.');
    	var lastProperty = pathArray.pop();

    	if (!_.isObject(obj)) {
    		return;
    	}

    	var lastObject = getPropertyByPathArray(obj, pathArray);

    	if (_.isObject(lastObject)) {
    		delete lastObject[lastProperty];
    	}
    };

    var getOrCreatePropertyByPathArray = function (obj, pathArray) {
    	var current = obj;
    	_.each(pathArray, function (property) {
    		if (!_.isObject(current[property])) {
    			current[property] = {};
    		}
    		current = current[property];
    	});

    	return current;
    };

    var setPropertyByPath = function (obj, path, value) {
    	var pathArray = typeof path === "number" ? [path] : path.split('.');
    	var lastProperty = pathArray.pop();

    	if (!_.isObject(obj)) {
    		return;
    	}

    	var lastObject = getOrCreatePropertyByPathArray(obj, pathArray);

    	lastObject[lastProperty] = value;
    };

    // this seemed pretty simple in theory and then snowballed... but it works well and is thoroughly tested
    var autoFormatNumber = function (number) {
        if (number === null || number === undefined)
            return number;
        if (!_.isFinite(number) || typeof number === 'string')
            return number.toString();

        var abs = Math.abs(number);
        var log10 = Math.log(abs) / Math.LN10;
        if (!_.isFinite(log10))
            return number.toString();

        if (log10 > 7 || log10 < -6)
            return number.toExponential(2); // 3 significant digits, eg. 1.23e+6

        var precision = 2 + (-Math.floor(log10)); // 3 significant digits, 12.345 -> 12.3; 0.012345 -> 0.0123
        if (precision <= 0)
            return number.toFixed(0);

        var formatted = number.toFixed(precision);
        while (formatted.charAt(formatted.length - 1) == '0') {
            formatted = formatted.substring(0, formatted.length - 1);
        }
        if (formatted.charAt(formatted.length - 1) == '.') {
            formatted = formatted.substring(0, formatted.length - 1);
        }
        return formatted;
    }

    return {
        cloneData: cloneData,
        parseUri: parseUri,
        addOrSetQueryParameter: addOrSetQueryParameter,
        addOrSetQueryParameterInUrl: addOrSetQueryParameterInUrl,
        parseUriQuery: parseUriQuery,
        formatUriQuery: formatUriQuery,
        convertRelativeHyperlinkToHostName: convertRelativeHyperlinkToHostName,
        getPropertyByPath: getPropertyByPath,
        setPropertyByPath: setPropertyByPath,
        removePropertyByPath: removePropertyByPath,
        autoFormatNumber: autoFormatNumber,
        convertListOfKeyValuesToObject: convertListOfKeyValuesToObject,
    };

});
